import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;
import { DeviceDetectorService  } from 'ngx-device-detector';

@Component({
    templateUrl: './AppViews/Task/TaskList.html'
})

export class TaskListComponent implements OnInit {
    userDetail: any;
    public constants: Constants;
    public myTask :any[];
    public taskGroupList:any[];
    public filterTaskTypeStatus:any="";
    public filterTasktype:any="";
    public taskType:any[];
    public filter:any={'TeamId':"",'UserId':"",'StatusId':"",'AssignedTo':"",'CreatedBy':"",'IsCurrent':true,'LoggedInUser':0,'Search':"",'DateRangeId' :"","subStatusId":""};
    public isAdd: boolean = true;
    active = true;
    public showLoader = false;
    public isFormSubmitted: boolean = false;
    public projectList:any[];
    public filterFlag: any;
    public usersItems:any[];
    teamList: any[];
    userList: any[];
    deviceInfo: any;
    StatusItems: any[];
    SubStatusItems: any[];
    users: any[];
     constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.filterFlag=JSON.parse(localStorage.getItem('TaskFilters'));
        if(this.filterFlag!=null && typeof this.filterFlag != 'undefined'){
          this.filter=JSON.parse(localStorage.getItem('TaskFilters'));
        }
        else{
            this.filter.AssignedTo = this.userDetail.SiteUserId;
            //this.filter.CreatedBy = this.userDetail.SiteUserId;
            
            let array = this.userDetail.TeamID.split(',');
            if(array != null && array.length==1)
             this.filter.TeamId = this.userDetail.TeamID;
        }
        this.epicFunction() ;
          localStorage.removeItem("TaskFilters")

    }
    epicFunction() {
        console.log('hello `Home` component');
      //  this.deviceInfo = this.deviceService.getDeviceInfo();
      //  console.log(this.deviceInfo);

      $(document).ready(function(){
        var ua = navigator.userAgent;
    
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua))
        this.deviceInfo = true;
    
        else if(/Chrome/i.test(ua))
        this.deviceInfo = false;
    
        else
        this.deviceInfo = false;
    
    });
      }
     newForm() {
         this.active = false;
         setTimeout(() => this.active = true, 0);
     }

    ngOnInit() {
        this.GetteamList();
        this.getMyTask();
        this.getStatus();
       // this.GetTaskType();
       // this.getUsers(0);
        this.GetUserList();
        this.getUsers();
    }


    ngAfterViewInit() {

        $("#show-filter").click(function () { $(".filter-form").slideToggle() });
    }

    public AddTeamFormLoad() {
        $('#btnAddTeamForm').trigger('click');
    }

    public ResetForm(form: any) {
        form.reset();
        form.resetForm();
        this.isFormSubmitted = false;
    }
     public clearFilter() {

        this.filter={'TeamId':"",'UserId':"",'StatusId':"",'AssignedTo':"",'CreatedBy':"",'IsCurrent':true,'LoggedInUser':0,'Search':"",'DateRangeId':"","subStatusId":""};

     }

    setFilters() {

        this.filter = {  'TeamId':this.filter.TeamId,'UserId':this.filter.UserId,'StatusId':this.filter.StatusId,'AssignedTo':this.filter.AssignedTo,'CreatedBy':this.filter.CreatedBy,'IsCurrent':this.filter.IsCurrent,'LoggedInUser':this.filter.LoggedInUser,'Search': this.filter.Search ,'DateRangeId':this.filter.DateRangeId,"subStatusId":this.filter.subStatusId };
        localStorage.setItem("TaskFilters",JSON.stringify(this.filter));
    }





    public getMyTask() {
        this.showLoader = true;
      
           if(this.userDetail.RoleId == this.constants.enumUserRole.Executive)
           {
            this.filter.AssignedTo = this.userDetail.SiteUserId;
            //this.filter.CreatedBy = this.userDetail.SiteUserId;
           
           }
           this._httpService.ajaxPost('MyTask/GetWWWTask', { "TeamId":this.filter.TeamId,"UserId":this.userDetail.SiteUserId,"StatusId":this.filter.StatusId,"AssignedTo":this.filter.AssignedTo,"CreatedBy":this.filter.CreatedBy,"IsCurrent":this.filter.IsCurrent,"LoggedInUser":this.userDetail.SiteUserId,"DateRangeId":this.filter.DateRangeId,"subStatusId":this.filter.subStatusId}).subscribe(
            data => {
                this.myTask = data["WWWTask"];
                this.myTask.forEach(element => {
                    let paldate =moment(new Date(element.PlannedEndDate)).format('YYYY-MM-DD');
                    element.PlannedStart= moment(new Date(element.PlannedStart)).format('DD/MM/YYYY');  
                    element.CreatedOn= moment(new Date(element.CreatedOn)).format('DD/MM/YYYY');
                 
                    let currDate = moment().format("YYYY-MM-DD");
                    let currentDate = new Date();
                    let plannedDate = new Date(element.PlannedEndDate);

                   var irtem = moment().isAfter(paldate,'day');
                    if ( currDate <= paldate) {
                        element.IsOverDue = false;
                        element.days =0;
                         } else {
                        element.IsOverDue = false;
                        element.IsOverDue = true;

                        element.days = Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) - Date.UTC(plannedDate.getFullYear(), plannedDate.getMonth(), plannedDate.getDate()) ) /(1000 * 60 * 60 * 24));

                    }
                });



            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    GetteamList() {
        // this.filter.UserId="";
        this.showLoader = true;
        //   this.filter.UserId="";
        this._httpService.ajaxPost("Team/GetAssignedTeam", { "TeamId": this.userDetail.TeamID, "UserId": this.userDetail.SiteUserId }).subscribe(
            data => {
                this.teamList = data["AssignedTeam"];
            },
            err => {
                console.log("GetTeamList Failed");
                this.showLoader = false;
            },
            () => {

                this.showLoader = false;
            }
        );
    }


    GetUserList() {
        console.log("wwwwwwwwwwww");
        //   this.filter.UserId="";
       this.showLoader = true;
       this._httpService.ajaxPost("Users/GetUsers",
            {
                "IsActive": this.constants.enumUserStatus["Active"],
                "Role": null,
                "Site": null,
                "Team": this.userDetail.TeamID,
                "UserId": this.userDetail.SiteUserId
           }).subscribe(
           data => {
               this.userList = data["Users"];
              $(".project").val('').selectpicker('refresh');
         },
         err => {
               console.log("GetUserList Failed");
             this.showLoader = false;
          },
         () => {
                this.showLoader = false;
            }
           );
    }

    
    public getUsers() {
        this.showLoader = true;
        this._httpService.ajaxPost('Users/GetAllUsers', {
            "IsActive": 1
        }).subscribe(
            data => {
                this.users = data["Users"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }
            );
    }
    public getStatus() {
        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.constants.enumParamterTypeName["TaskStatusType"] }).subscribe(
             data => {

                 this.StatusItems = data["Parameter"];
                 this.StatusItems =this.StatusItems.filter(x=>x.Value != 1 && x.Value != 7);
        }
          );
      }

    getSubStatus(){
        this.filter.subStatusId ="";
        if(this.filter.StatusId == 1)
        this.SubStatusItems = this.StatusItems.filter(x=>(x.Value == 2 || x.Value == 3 )) 
        if(this.filter.StatusId == 2)
        this.SubStatusItems = this.StatusItems.filter(x=>(x.Value == 6 || x.Value == 4)) 
      
    }

    
    ExportItems() {
        ExportToExcel(this.myTask, "WWW Task",
        ["TaskId", "AssignedToName","TaskName","PlannedStart","StatusName","CreatedOn","CreatedByName"],
        ["Id", "Who","What","When","Status","Created On","Created By"]);

           
         
    }
}



/** WEBPACK FOOTER **
 ** ./TypeScripts/Task/TaskList.component.ts
 **/


/** WEBPACK FOOTER **
 ** ./TypeScripts/Task/TaskList.component.ts
 **/